export function formatDate(string: string) {
    return new Date(string).toLocaleDateString('en-US')
}

export const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})
